


































import { Vue, Component, Prop } from 'vue-property-decorator';
import SearchInput from '@shared/components/forms/inputs/search-input.vue';
import EntitySelect from '@shared/components/forms/inputs/entity-select/entity-select.vue';
import MultiSelect from '@shared/components/forms/inputs/multi-select/multi-select.vue';
import { SelectOptionInterface } from '@shared/interfaces/inputs';

@Component({
  components: {
    'bpc-search-input': SearchInput,
    'bpc-entity-select': EntitySelect,
    'bpc-multi-select': MultiSelect,
  },
})
export default class ActivitySessionWaitingContactsFilters extends Vue {
  // PROPS
  @Prop({ type: Object, required: true }) value!: {
    search: string | null;
    contact_ids: number[];
    activity_session_ids: number[];
  };
  @Prop({ type: Function, required: true }) readonly clickOnReload!: () => void;

  // COMPUTED
  get model() {
    return this.value;
  }

  set model(value) {
    this.$emit('input', value);
  }

  get hideInputLabel() {
    return {
      labelAttributes: {
        for: 'input',
      },
    };
  }
}
